import { getResolvedFrontendGraphqlUrls } from './resolveFrontendGraphqlUrls';
import { createApi } from '@reduxjs/toolkit/query/react';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { GraphQLClient } from 'graphql-request';
import { getSegmentAnonymousId } from '@doxyme/frontend/features/tracking/trackers/segment/cookies.segment';

const getGraphEndpoint = (): string => {
  try {
    return getResolvedFrontendGraphqlUrls().graphqlUrl;
  } catch (error) {
    console.error('Failed to resolve GraphQL endpoint:', error);
    throw new Error('GraphQL configuration is missing or invalid');
  }
};

const graphEndpoint = getGraphEndpoint();
// Authorization header will be added by useUpdateApiHeaders hook once the user is authenticated
export const client = new GraphQLClient(graphEndpoint);

// Store base headers (like Authorization) separately since headers is now a function
let baseHeaders: Record<string, string> = {};

// Set headers as a function that dynamically includes anonymousId
// This function is called on every request, ensuring anonymousId is always up-to-date
// It merges anonymousId with base headers (like Authorization)
client.requestConfig.headers = () => {
  // Include anonymousId if available
  const anonymousId = getSegmentAnonymousId();
  if (anonymousId) {
    return {
      ...baseHeaders,
      'x-segment-anonymous-id': anonymousId,
    };
  }

  return baseHeaders;
};

export const graphQlService = createApi({
  reducerPath: 'apolloApi',
  baseQuery: graphqlRequestBaseQuery({ client }),
  tagTypes: ['TenantUser'],
  endpoints: () => ({}),
});

export const updateGraphQLAuthHeader = (bearer: string) => {
  // Update base headers instead of using setHeaders (since headers is now a function)
  baseHeaders = {
    ...baseHeaders,
    Authorization: bearer,
  };
};
